import React from 'react';
import { ShieldCheck, Wrench, AlertOctagon, History, FolderKanban } from 'lucide-react';
import { TunnelStatus } from '../types';

interface StatusBannerProps {
  status: TunnelStatus | null;
  stashCount: number;
  pendingCount: number;
}

export const StatusBanner: React.FC<StatusBannerProps> = ({ status, stashCount, pendingCount }) => {
  return (
    <div className="metrics-row">
      <div className="metric-card">
        <div className="metric-header">
          <span>Security Mode</span>
          <ShieldCheck size={16} color="var(--accent-green)" />
        </div>
        <div className="metric-value" style={{ color: status?.mode === 'WORK' ? 'var(--accent-green)' : 'var(--accent-amber)' }}>
          {status?.mode || 'WORK'}
        </div>
        <div className="metric-subtitle">
          {status?.mode === 'WORK' ? 'Restricted to Workspace Root' : 'Full Machine Access Allowed'}
        </div>
      </div>

      <div className="metric-card">
        <div className="metric-header">
          <span>Active MCP Tools</span>
          <Wrench size={16} color="var(--accent-cyan)" />
        </div>
        <div className="metric-value" style={{ color: 'var(--accent-cyan)' }}>
          {status?.totalTools ?? 56}
        </div>
        <div className="metric-subtitle">14 Modules (Workspace, Git, Shell, Vision, DOM)</div>
      </div>

      <div className="metric-card">
        <div className="metric-header">
          <span>Pending Approvals</span>
          <AlertOctagon size={16} color={pendingCount > 0 ? 'var(--accent-red)' : 'var(--text-muted)'} />
        </div>
        <div className="metric-value" style={{ color: pendingCount > 0 ? 'var(--accent-red)' : 'var(--text-primary)' }}>
          {pendingCount}
        </div>
        <div className="metric-subtitle">
          {pendingCount > 0 ? 'Action required by user' : 'No blocked operations'}
        </div>
      </div>

      <div className="metric-card">
        <div className="metric-header">
          <span>Shadow Stash Backups</span>
          <History size={16} color="var(--accent-blue)" />
        </div>
        <div className="metric-value" style={{ color: 'var(--accent-blue)' }}>
          {stashCount}
        </div>
        <div className="metric-subtitle">1-Click rollback snapshots available</div>
      </div>
    </div>
  );
};
